module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "en"
    }
  }, [_c('div', {
    staticClass: "vheader"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _c('ul', [_c('li', {
    class: {
      active: _vm.$route.name == 'index'
    }
  }, [_c('a', {
    attrs: {
      "href": "http://f.geekpark.net"
    }
  }, [_vm._v("CN")])])])])]), _c('div', {
    staticClass: "banner-en"
  }, [_c('div', {
    staticClass: "en-pics"
  }, [_c('img', {
    attrs: {
      "srcset": ("/static/img/banner-m-0" + _vm.step + ".jpg 1000w, /static/img/banner-0" + _vm.step + ".jpg 1080w"),
      "src": ("/static/img/banner-0" + _vm.step + ".jpg")
    }
  })]), _vm._m(1)]), _vm._m(2), _c('div', {
    staticClass: "funders"
  }, [_c('div', {
    staticClass: "container padding"
  }, [_c('h1', [_vm._v("the most remarkable startup FOUNDERS")]), _vm._m(3), _c('div', {
    staticClass: "expert-wapper"
  }, [_c('ul', _vm._l((_vm.whoareat.items), function(item, $index) {
    return _c('li', {
      staticClass: "expert-item"
    }, [_c('img', {
      attrs: {
        "src": ['/static/img/' + item.pic]
      }
    }), _c('div', {
      staticClass: "info"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _c('p', {
      staticClass: "from"
    }, [_vm._v(_vm._s(item.from))]), _c('p', {
      staticClass: "position",
      domProps: {
        "innerHTML": _vm._s(item.position)
      }
    })])])
  }), 0)])])]), _c('div', {
    staticClass: "linked"
  }, [_c('div', {
    staticClass: "container padding"
  }, [_c('h1', {
    staticClass: "relative"
  }, [_vm._v("WHO WE LINKED")]), _vm._m(4), _vm._m(5), _c('div', {
    staticClass: "friends"
  }, [_c('h2', [_vm._v("GEEKPARK’S FRIENDS")]), _c('ul', _vm._l((_vm.friends.items), function(item, $index) {
    return _c('li', [_c('img', {
      attrs: {
        "src": ['/static/img/' + item.pic]
      }
    }), _c('div', {
      staticClass: "info"
    }, [_c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _c('p', {
      staticClass: "company"
    }, [_vm._v(_vm._s(item.company))]), _c('p', {
      staticClass: "position"
    }, [_vm._v(_vm._s(item.position))])])])
  }), 0)])])]), _vm._m(6), _vm._m(7)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://f.geekpark.net"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/imgs/header-logo-m.png"),
      "alt": "Frontier"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "en-block"
  }, [_c('div', {
    staticClass: "container padding"
  }, [_c('div', {
    staticClass: "title-block"
  }, [_c('h1', [_vm._v("GET"), _c('br'), _vm._v("LINKED &"), _c('br'), _vm._v("PLUGGED")]), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Where core players of the Chinese tech industry get linked and plugged")]), _c('p', {
    staticClass: "ps"
  }, [_vm._v("With like-minded innovators worldwide"), _c('br'), _vm._v("With science, tech, and business innovation"), _c('br'), _vm._v("With all things that may change games")])])]), _c('div', {
    staticClass: "video-block"
  }, [_c('h2', [_vm._v("Keep always fresh"), _c('br'), _vm._v("Get always ready")]), _c('p', {
    staticClass: "ps"
  }, [_vm._v("Builds up a decentralized life-learning community to share true insights,\ndiscuss real problems, spark intensive thinking.")])]), _c('div', {
    staticClass: "list-block"
  }, [_c('dl', [_c('dd', [_c('div', {
    staticClass: "desc"
  }, [_vm._v("Not"), _c('br'), _vm._v("what’s new")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("But what matters")]), _c('p', {
    staticClass: "ps"
  }, [_vm._v("We set well-chosen topics for discussion, even debate. Only select what’s important, what’s notable, and what’s worth taking time to zoom in.")])]), _c('dd', [_c('div', {
    staticClass: "desc"
  }, [_vm._v("Not"), _c('br'), _vm._v("what’s known")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("But what's going on")]), _c('p', {
    staticClass: "ps"
  }, [_vm._v("For the new generation entrepreneurs, they need hands-on know-how, instead of printed knowledge, because they are more often faced with problems that never happen.")])]), _c('dd', [_c('div', {
    staticClass: "desc"
  }, [_vm._v("Not"), _c('br'), _vm._v("training")]), _c('div', {
    staticClass: "title"
  }, [_vm._v("But what learning")]), _c('p', {
    staticClass: "ps"
  }, [_vm._v("Socratic discussions are often the most inspiring and the most effective way to get a thorough view. Here, no tutors, but views collisions.")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invitation"
  }, [_c('div', {
    staticClass: "container padding"
  }, [_c('h1', [_vm._v("INVITATION-Only EVENTS")]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("FIELD STUDY")]), _c('div', {
    staticClass: "title-second"
  }, [_vm._v("CEO VS CEOS")]), _c('p', {
    staticClass: "ps"
  }, [_vm._v("Decentralized discussions among founders who know founders’ challenges best.")])]), _c('div', {
    staticClass: "talk"
  }, [_vm._v("We Talk About ...")]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("For a tech company of today, who has to grow fast to live.")]), _c('p', {
    staticClass: "ps"
  }, [_vm._v("• Vision VS Reality — how to balance the energy put on each"), _c('br'), _vm._v("• Mission & Culture — how to maintain a strong company culture as you grow"), _c('br'), _vm._v("• Leadership & Management — how to lead and manage to keep both efficient and creative"), _c('br'), _vm._v("• Product & Business — how a tech company define and construct its product and business models")])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("FRONTIER WORKSHOp")]), _c('div', {
    staticClass: "title-second"
  }, [_vm._v("Industry VS Academia")]), _c('p', {
    staticClass: "ps"
  }, [_vm._v("Link top academic institutions and academic leaders across the world with the tech industry")])]), _c('div', {
    staticClass: "talk"
  }, [_vm._v("We Talk About ...")]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Trending Areas")]), _c('p', {
    staticClass: "ps"
  }, [_vm._v("AI & AI Applications / Data Science / IoT / Self Driving & New Transportation / Artificial Satellite & Space Exploration / Robotics / ......")])]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Fundamental Research")]), _c('p', {
    staticClass: "ps"
  }, [_vm._v("Neuroscience / Life Science / Mechanical Engineering / Electric Engineering / Applied Mathematics / Applied Physics / Material Science / ...")])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("OVERCLOCKING CAMP")]), _c('div', {
    staticClass: "title-second"
  }, [_vm._v("Map Out Global Innovations")]), _c('p', {
    staticClass: "ps"
  }, [_vm._v("Immersive dialogues at a line of tech titans, startups to watch, and research institutions.")])]), _c('div', {
    staticClass: "talk"
  }, [_vm._v("USA / Canada /Israel / Europe ...")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "items-list"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Valuations :"), _c('br'), _vm._v(">50% with $1 Billion"), _c('br'), _vm._v(">25% with $100 Million+")]), _c('p', {
    staticClass: "ps"
  }, [_vm._v("They are technologists, who address big problems that impact thousands millions of people.")])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Insightful Tech Leaders")]), _c('p', {
    staticClass: "ps"
  }, [_vm._v("They know algorithms, but they know better that algorithms are not the final goal. It is them who make tech be products, and make products matter.")])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("New-mindset-equipped Investors")]), _c('p', {
    staticClass: "ps"
  }, [_vm._v("They know how to be a launchpad for emerging ideas. And they know how to make things closer to happen.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-no"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/map.jpg"),
      "alt": "我们曾抵达..."
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footprint"
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/en-linked-01.jpg")
    }
  }), _c('p', [_vm._v("Meet Apple’s former CEO John Sculley")])]), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/en-linked-02.jpg")
    }
  }), _c('p', [_vm._v("In-depth communications @Google")])]), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/en-linked-03.jpg")
    }
  }), _c('p', [_vm._v("GeekPark’s China-theme forum @ Facebook")])]), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/en-linked-04.jpg")
    }
  }), _c('p', [_vm._v("Meet Twitter’s former CEO Dick Costolo")])]), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/en-linked-05.jpg")
    }
  }), _c('p', [_vm._v("@Nvidia")])]), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/en-linked-06.jpg")
    }
  }), _c('p', [_vm._v("@Pinterest")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "container padding"
  }, [_c('h1', [_vm._v("About GeekPark")]), _c('div', {
    staticClass: "center max-w about-meet"
  }, [_c('h2', [_vm._v("To Meet Your Like-Minded"), _c('br'), _vm._v("at GeekPark")]), _c('p', {
    staticClass: "center ps"
  }, [_vm._v("Founded in 2010, GeekPark is one of China’s largest internet and technology innovation communities,"), _c('br'), _vm._v("as well as the first one who introduces the concept “Geek” into China. "), _c('br'), _vm._v("Over the past seven years, GeekPark has developed to be a notable force of the innovators & for the innovators")])]), _c('div', {
    staticClass: "list-block"
  }, [_c('dl', [_c('dd', [_c('div', {
    staticClass: "title"
  }, [_vm._v("GeekPark"), _c('br'), _vm._v("Media")]), _c('div', {
    staticClass: "desc-t"
  }, [_c('b', [_vm._v("Renowned")]), _c('br'), _vm._v("Independent"), _c('br'), _vm._v("Tech Media")]), _c('p', {
    staticClass: "ps"
  }, [_vm._v("300,000 Readers")])]), _c('dd', [_c('div', {
    staticClass: "title"
  }, [_vm._v("The"), _c('br'), _vm._v("Frontier")]), _c('div', {
    staticClass: "desc-t"
  }, [_c('b', [_vm._v("High-profile")]), _c('br'), _vm._v("Tech Leaders"), _c('br'), _vm._v("Association")]), _c('p', {
    staticClass: "ps"
  }, [_vm._v("50 New Members Enrolled Every Year from TOP 5% Tech Companies")])]), _c('dd', [_c('div', {
    staticClass: "title"
  }, [_vm._v("GeekPark IF"), _c('br'), _vm._v("& Rebuild")]), _c('div', {
    staticClass: "desc-t"
  }, [_c('b', [_vm._v("Influential")]), _c('br'), _vm._v("Annual Events"), _c('br'), _vm._v("For Innovators")]), _c('p', {
    staticClass: "ps"
  }, [_vm._v("The Most High-quality Tech Events in China With 10,000+ Attendees and Speakers from All over the World")])])])]), _c('div', {
    staticClass: "help"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/en-about.jpg")
    }
  })]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("We help you better"), _c('br'), _c('b', [_vm._v("access to resources,")]), _c('br'), _c('b', [_vm._v("build up image and release impact")]), _vm._v(" in China.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vfooter"
  }, [_c('div', {
    staticClass: "footer-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "contact"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/tel.svg")
    }
  }), _vm._v("132 6332 1278")]), _c('p', [_c('a', {
    staticClass: "mail",
    attrs: {
      "href": "mailto:thefrontier@geekpark.net"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/mail.svg")
    }
  }), _vm._v("thefrontier@geekpark.net")])]), _c('p', {
    staticClass: "site"
  }, [_vm._v("Powered by "), _c('a', {
    attrs: {
      "href": "http://www.geekpark.net",
      "target": "_blank"
    }
  }, [_vm._v("GeekPark")])])]), _c('div', {
    staticClass: "follow"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/qrcode.jpg"),
      "alt": "前沿社公众号"
    }
  }), _c('br'), _vm._v("Follow us")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e317ab7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/En.vue
// module id = 203
// module chunks = 1